import { render } from "./Introducao.vue?vue&type=template&id=f62d7fe2&scoped=true&bindings={\"profsList\":\"setup\"}"
import script from "./Introducao.vue?vue&type=script&lang=js"
export * from "./Introducao.vue?vue&type=script&lang=js"

import "./Introducao.vue?vue&type=style&index=0&id=f62d7fe2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f62d7fe2"

export default script